import { gateway } from "../../../gateway";

export async function switchCompany({ companyId }: { companyId: number }) {
  const token = sessionStorage.getItem("token");

  const res = await gateway.post(
    `/users/switch-company/${companyId}`,
    {},
    {
      headers: {
        Authorization: token?.startsWith("Bearer ") ? token : `Bearer ${token}`,
      },
    },
  );

  return res?.data?.data ?? res?.data;
}

export async function fetchCompanyData({ companyId }: { companyId: number }) {
  const token = sessionStorage.getItem("token");

  const res = await gateway.get(`/users/self/company/${companyId}`, {
    headers: {
      Authorization: token?.startsWith("Bearer ") ? token : `Bearer ${token}`,
    },
  });

  return res?.data?.data ?? res?.data;
}

export async function updateCompany(payload) {
  const token = sessionStorage.getItem("token");

  const res = await gateway.patch(`/companies/self`, payload, {
    headers: {
      Authorization: token?.startsWith("Bearer ") ? token : `Bearer ${token}`,
    },
  });

  return res?.data?.data ?? res?.data;
}
